"use client";
import Image from 'next/image';
import LinkUrl from '../../../common/general/link/LinkUrl';
import HeaderActions from '../partials/header-actions/HeaderActions';
import HeaderMenu from '../partials/header-menu/HeaderMenu';
import style from './headerDesktop.module.scss';
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';
import { useEffect, useState } from 'react';
import Container from '../../../common/general/container/Container';
import MenuItemDto from '@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto';
import { Language } from '@/projectRoot/routes.config';
import NotificationDto from '@/projectRoot/api-client/interfaces/models/content/Notification.dto';
import Notifications from '../notifications/Notifications';
import { Link } from '@/projectRoot/src/i18n/navigation';

interface Props {
  menu_items: MenuItemDto[];
  multilang_slugs?: Record<Language, string>;
  notifications?: NotificationDto[];
  route_parameter?: {
    list?: string;
    single?: string;
  }
}

const HeaderDesktop = ({menu_items, multilang_slugs, route_parameter, notifications}: Props) => {

    const [isHovered, setIsHovered] = useState<boolean>(false);
    const [isScrolled, setIsScrolled] = useState<boolean>(false);
    const onHoverMenuItem = (hovered: boolean) => {
      setIsHovered(hovered);
    }

    const onScrollSetBackground = () => {
      setIsScrolled(window.scrollY > 80);
    }

    let coloredBg = (multilang_slugs ? (multilang_slugs.sr != process.env.NEXT_PUBLIC_APP_URL && multilang_slugs.en != process.env.NEXT_PUBLIC_APP_URL + '/en') : true);

    useEffect(() => {
      if(typeof window !== 'undefined'){
        window.addEventListener('scroll', onScrollSetBackground);
        return () => {
          window.removeEventListener('scroll', onScrollSetBackground);
        }
      }
    }, []);

  return (
    <section className={`${style.headerDesktop} ${coloredBg || isHovered || isScrolled ? style.hovered : ''}`}>
      {
        notifications
        ?
        <Notifications 
          classes={coloredBg || isHovered || isScrolled ? [style.darkNotification] : [style.lightNotification]} 
          notifications={notifications} 
        />
        : <></>
      }
      <Container>
        <div className={style.wrapper}>
          {
            coloredBg || isHovered || isScrolled
            ?
            <Link className={style.logo} href={'/'} >
              <Image src={'/cubes-logo-dark.png'} width={120} height={34} alt='logo' objectFit='contain' />
            </Link>
            :
            <Link className={style.logo} href={'/'} >
              <Image src={'/cubes-logo.png'} width={120} height={34} alt='logo' objectFit='contain' />
            </Link>
          }
          <HeaderMenu 
            menu_items={menu_items} 
            classes={[style.menu]} 
            onHoverItem={onHoverMenuItem} 
            isHovered={coloredBg || isHovered || isScrolled} 
            multilang_slugs={multilang_slugs}
            route_parameter={route_parameter}
          />
          <HeaderActions hovered={coloredBg || isHovered || isScrolled} classes={[style.actions]} multilang_slugs={multilang_slugs} route_parameter={route_parameter} />
        </div>
      </Container>
    </section>
  )
};

export default HeaderDesktop;
